import { IConfigureRequest } from '../../types';

/**
 * This method creates a configure request object with formatted properties
 * @param {IConfigureRequest} configRequest the configuration request object
 * @param {string} viewId the view identifier
 * @param {string} productId the product identifier
 * @returns {object} returns the formatted configure request object
 */
export function createConfigureRequest(
  configRequest: IConfigureRequest,
  viewId: string,
  productId: string
) {
  return {
    configurationId: configRequest.configurationId,
    productId: productId,
    view: viewId,
    assignments: configRequest.line.variableAssignments,
    language: configRequest.language,
    fulfilmentDate: configRequest.date,
  };
}

/**
 * Parses the package path from the configuration store into its type and code parts.
 * Package path format: "C{packageCode}/{packageType}{packageCode}~{guid}" (e.g. "C782199/R782199~ab8c8984-...").
 * @returns {{ packageCode: string, packageType: string } | null} The parsed package details, or null if unavailable or malformed.
 */
export function getPackageDetails(packagePath: string): {
  packageCode: string;
  packageType: string;
} {
  const [pathPart, typePart] = packagePath.split('/');

  const packageCode = pathPart.slice(1);
  const packageType = typePart.charAt(0);

  return {
    packageType,
    packageCode,
  };
}
